import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaStore, FaTimes } from 'react-icons/fa';
import './AddRestaurantModal.scss';

interface AddRestaurantModalProps {
    show: boolean;
    onClose: () => void;
    onSubscribe: (code: string) => void;
}

const AddRestaurantModal: React.FC<AddRestaurantModalProps> = ({ show, onClose, onSubscribe }) => {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = () => {
        // Validate code format (ABCD-1234)
        const codePattern = /^[A-Z]{4}-\d{4}$/;
        if (!codePattern.test(code.toUpperCase())) {
            setError('Formato inválido. Debe ser ABCD-1234');
            return;
        }

        setError('');
        onSubscribe(code.toUpperCase());
        setCode('');
        onClose();
    };

    const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value.toUpperCase();
        
        // Auto-format: add dash after 4 characters
        if (value.length === 4 && !value.includes('-')) {
            value = value + '-';
        }
        
        // Limit to ABCD-1234 format (9 characters max)
        if (value.length <= 9) {
            setCode(value);
            setError('');
        }
    };

    const handleClose = () => {
        setCode('');
        setError('');
        onClose();
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            centered
            className="add-restaurant-modal"
        >
            <Modal.Body className="add-restaurant-body">
                <button className="close-button" onClick={handleClose}>
                    <FaTimes />
                </button>

                <div className="modal-icon">
                    <FaStore />
                </div>

                <h2 className="modal-title">Agregar Restaurante</h2>
                <p className="modal-description">
                    Ingresa el código que el restaurante te proporcionó para suscribirte
                </p>

                <div className="code-input-container">
                    <input
                        type="text"
                        className={`code-input ${error ? 'error' : ''}`}
                        placeholder="ABCD-1234"
                        value={code}
                        onChange={handleCodeChange}
                        maxLength={9}
                    />
                    {error && <span className="error-message">{error}</span>}
                </div>

                <div className="modal-info">
                    <p>💡 El restaurante te puede proporcionar este código o enviar un enlace directo</p>
                </div>

                <div className="modal-actions">
                    <Button 
                        variant="secondary" 
                        onClick={handleClose}
                        className="cancel-button"
                    >
                        Cancelar
                    </Button>
                    <Button 
                        variant="primary" 
                        onClick={handleSubmit}
                        className="subscribe-button"
                        disabled={code.length < 9}
                    >
                        Suscribirse
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddRestaurantModal;
